import { createPortal } from 'react-dom'
import {
  Link as RouterLink,
  type LinkProps as RouterLinkProps,
} from 'react-router'
import {
  Box,
  Link,
  LinkProps,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import useLocationHelpers from '@/hooks/useLocationHelpers'
import { useBreadcrumbPortalContext } from './BreadcrumbPortalProvider'

function LinkRouter(props: RouterLinkProps & LinkProps) {
  return <Link {...props} component={RouterLink} />
}

type BreadcrumbProps = {
  label: string
  url?: string
  includeQueryParams?: boolean
}

export default function Breadcrumb({
  label,
  url,
  includeQueryParams,
}: BreadcrumbProps) {
  const [portalNode] = useBreadcrumbPortalContext()
  const { appendCurrentParamsToUrl } = useLocationHelpers()
  const theme = useTheme()
  return portalNode
    ? createPortal(
        <Stack
          direction="row"
          spacing={1}
          sx={{
            ml: 1,
            a: {
              maxWidth: '400px',
            },
            '&:last-child': {
              opacity: 0.75,
            },
          }}
        >
          <Box
            sx={{
              transform: 'rotate(15deg)',
              borderRight: '1px solid currentColor',
              height: '0.9em',
              mt: '3px !important',
              opacity: 0.65,
              color: 'text.primary',
            }}
          />
          <Typography variant="body2" noWrap color="text.secondary">
            {url ? (
              <LinkRouter
                noWrap
                underline="hover"
                color={theme.palette.text.secondary}
                to={includeQueryParams ? appendCurrentParamsToUrl(url) : url}
                sx={{
                  display: 'inline-block', // so ellipsifying works
                }}
              >
                {label}
              </LinkRouter>
            ) : (
              <Typography
                component="span"
                variant="inherit"
                sx={{ display: 'inline-block' }}
              >
                {label}
              </Typography>
            )}
          </Typography>
        </Stack>,
        portalNode,
      )
    : null
}
